export type QualityCheckType = {
  [reviewType: string]: {
    [categoryName: string]: Array<{
      type: string;
      name: string;
      summary?: string;
    }>;
  };
};

export enum QcReviewName {
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PASSED = 'PASSED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  FAILED = 'FAILED',
}
